import { getCities } from "@/api/cities";

export default async (scheme, typeScheme) => {
  const { properties = {} } = scheme;
  const { type, cities } = properties;

  // добавляем значение типа схемы
  // для отображения нужной при множественном кол-ве схем
  if (typeScheme && type) {
    type.value = typeScheme;
  }
  // добавляем список городов
  if (cities) {
    const data = await getCities();
    data.params = { key: "id", label: "description", multiple: true };
    Object.assign(cities, data);
  }

  return scheme;
};
